(function ($, Drupal, once) {
  Drupal.behaviors.pageModal = {
    attach(context) {
      once('pageModal', 'html', context).forEach((html) => {
        const navigation = html.querySelector('#navigation');
        const openTriggers = html.querySelectorAll('[data-modal]:not(.modal-close)');
        const closeTriggers = html.querySelectorAll('.modal-close[data-modal]');

        openTriggers.forEach((trigger) => {
          const selector = trigger.dataset.modal;
          const modal = html.querySelector(selector);
          const type = selector.replace('#', '').replace('-form', '');
          const expandCls = `is-expanded-${type}`;

          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            html.classList.add('prevent--overflow');
            navigation.classList.add(expandCls);
            navigation.classList.remove('is-expanded');
            ['contact', 'newsletter'].filter((t) => t !== type).forEach((t) => navigation.classList.remove(`is-expanded-${t}`));
            trigger.dataset[`expanded${type.charAt(0).toUpperCase() + type.slice(1)}`] = 'true';
            modal.dataset[`expanded${type.charAt(0).toUpperCase() + type.slice(1)}`] = 'true';

            const { selectedValue } = trigger.dataset;
            if (type === 'contact' && selectedValue) {
              modal.dataset.pendingValue = selectedValue;
              setTimeout(() => {
                const $select = $(modal).find('select[name="type_of_residence"]');
                if ($select.length) {
                  $select.val(selectedValue).trigger('change');
                }
              }, 200);
            }
          });
        });

        closeTriggers.forEach((trigger) => {
          const selector = trigger.dataset.modal;
          const modal = html.querySelector(selector);
          const type = selector.replace('#', '').replace('-form', '');
          const expandCls = `is-expanded-${type}`;

          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            html.classList.remove('prevent--overflow');
            navigation.classList.remove(expandCls);
            trigger.dataset[`expanded${type.charAt(0).toUpperCase() + type.slice(1)}`] = 'false';
            modal.dataset[`expanded${type.charAt(0).toUpperCase() + type.slice(1)}`] = 'false';
          });
        });
      });
    },
  };
}(jQuery, Drupal, once));
